
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import { showEqualWebDrawer } from '../helpers/equalWeb';
import i18n from '../i18n';
import { TranslateResult } from 'vue-i18n';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';

export default Vue.extend({
  name: 'HeaderLessonMobile',
  components: {
    Icon,
  },
  computed: {
    shouldShowAccessibilityIcon(): boolean {
      return this.$store.getters.shouldShowEqualWebWidget;
    },
    close(): TranslateResult {
      return i18n.t('closeButton');
    },
  },
  methods: {
    trackAccessibilityIconClick(): void {
      Analytics.trackEvent(EVENT_LABELS.acessibilityButtonClick, {
        is_drawer_open_button: true,
        is_inside_class: true,
      });
    },
    showEqualWebDrawerAndTrack(): void {
      this.trackAccessibilityIconClick();

      showEqualWebDrawer();
    },
    onBulletListClick(): void {
      this.$emit('onBulletListClick');
    },
    onCloseClick(): void {
      this.$emit('onCloseClick');
    },
  },
});
